/* INSCAPE Landing Page – lp-* Sections */
(function () {
  'use strict';
  if (window.__lpLanding) return;
  window.__lpLanding = true;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Galerie ---------- */
  function initGallery(root) {
    $$('[data-lp-gallery]', root).forEach(function (gal) {
      if (gal.__lp) return; gal.__lp = true;
      var track = $('[data-lp-track]', gal);
      if (!track) return;
      var slides = $$('.lp-gal__slide', track);
      var dotsWrap = $('[data-lp-dots]', gal);
      var counter = $('[data-lp-counter]', gal);
      var thumbsWrap = gal.parentNode ? $('[data-lp-thumbs]', gal.parentNode) : null;
      var prev = $('[data-lp-prev]', gal), next = $('[data-lp-next]', gal);
      if (slides.length < 2) {
        if (prev) prev.hidden = true; if (next) next.hidden = true;
        return;
      }
      var useDots = slides.length <= 9;
      var dots = [], thumbs = [], current = -1;

      slides.forEach(function (s, i) {
        if (dotsWrap && useDots) {
          var d = document.createElement('span');
          d.className = 'lp-gal__dot';
          dotsWrap.appendChild(d); dots.push(d);
        }
        if (thumbsWrap) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'lp-gal__thumb';
          b.setAttribute('aria-label', (thumbsWrap.getAttribute('data-label') || '__N__').replace('__N__', i + 1));
          var src = s.getAttribute('data-thumb');
          if (src) { var im = document.createElement('img'); im.src = src; im.alt = ''; im.loading = 'lazy'; im.width = 160; im.height = 160; b.appendChild(im); }
          b.addEventListener('click', function () { go(i); });
          thumbsWrap.appendChild(b); thumbs.push(b);
        }
      });
      if (!useDots && counter) counter.hidden = false;

      function setActive(i) {
        if (i === current) return; current = i;
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
        // aktive Vorschau in der Leiste sichtbar halten (nur innerhalb der Leiste scrollen, nicht die Seite)
        var at = thumbs[i];
        if (at && thumbsWrap && thumbsWrap.scrollWidth > thumbsWrap.clientWidth) {
          var l = at.offsetLeft; // Leiste ist position:relative -> offsetLeft relativ zur Leiste
          if (l < thumbsWrap.scrollLeft || l + at.offsetWidth > thumbsWrap.scrollLeft + thumbsWrap.clientWidth) {
            thumbsWrap.scrollTo({ left: Math.max(0, l - (thumbsWrap.clientWidth - at.offsetWidth) / 2), behavior: 'smooth' });
          }
        }
        if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      }
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = track.clientWidth || 1;
          setActive(Math.round(track.scrollLeft / w));
        });
      }, { passive: true });
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      setActive(0);
    });
  }

  /* ---------- Angebote ---------- */
  function syncPrices(radio) {
    if (!radio) return;
    var d = radio.dataset;
    // Preise kommen aus dem money-Filter (inkl. evtl. Waehrungs-App-Markup) -> innerHTML
    $$('[data-lp-price]').forEach(function (el) { el.innerHTML = d.price; });
    $$('[data-lp-compare]').forEach(function (el) { el.innerHTML = d.compare || ''; el.hidden = !d.compare; });
    $$('[data-lp-offer-title]').forEach(function (el) { if (d.title) el.textContent = d.title; });
    var available = d.available === 'true';
    $$('[data-lp-atc]').forEach(function (b) {
      b.disabled = !available;
      var lbl = $('[data-lp-atc-label]', b);
      if (lbl && b.dataset.soldout && b.dataset.label) lbl.textContent = available ? b.dataset.label : b.dataset.soldout;
    });
  }
  function initOffers(root) {
    $$('[data-lp-hero]', root).forEach(function (hero) {
      if (hero.__lpOffers) return; hero.__lpOffers = true;
      var input = $('[data-lp-variant-input]', hero);
      var radios = $$('.lp-offer__radio', hero);
      function update(e) {
        var sel = null;
        radios.forEach(function (r) {
          var card = r.closest('.lp-offer');
          if (card) card.classList.toggle('is-selected', r.checked);
          if (r.checked) sel = r;
        });
        if (!sel) return;
        if (input) input.value = sel.value;
        if (e) syncPrices(sel); // nur bei echter Auswahl, Liquid rendert den Startzustand
      }
      radios.forEach(function (r) { r.addEventListener('change', update); });
      update(null);
    });
  }

  /* ---------- Liefertermin ---------- */
  function isWeekend(d) { var w = d.getDay(); return w === 0 || w === 6; }
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime()), added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (!isWeekend(d)) added++;
    }
    return d;
  }
  // Aktuelles Datum/Uhrzeit am Lagerstandort (Versand-Cut-off gilt in deutscher Zeit)
  function nowIn(tz) {
    var now = new Date();
    if (!tz || !window.Intl) return now;
    try {
      var p = {};
      new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
        .formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
      return new Date(+p.year, +p.month - 1, +p.day, +p.hour % 24, 0, 0);
    } catch (e) { return now; }
  }
  function dateFormatter(locales) {
    for (var i = 0; i < locales.length; i++) {
      if (!locales[i]) continue;
      try { return new Intl.DateTimeFormat(locales[i], { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) {}
    }
    return { format: function (x) { return x.toLocaleDateString(); } };
  }
  function initDelivery(root) {
    $$('[data-lp-delivery]', root).forEach(function (el) {
      var min = parseInt(el.dataset.min, 10) || 0;
      var max = parseInt(el.dataset.max, 10) || 0;
      if (!max) return;
      if (min > max) min = max;
      var cutoff = parseInt(el.dataset.cutoff, 10) || 0;
      // Versandtag: heute, wenn Werktag und vor dem Cut-off – sonst nächster Werktag
      var ship = nowIn(el.dataset.tz);
      var shipsToday = !isWeekend(ship) && (cutoff === 0 || ship.getHours() < cutoff);
      if (!shipsToday) ship = addBusinessDays(ship, 1);
      var a = addBusinessDays(ship, min), b = addBusinessDays(ship, max);
      var lang = document.documentElement.lang || 'de';
      var fmt = dateFormatter([el.dataset.locale, lang, 'de']);
      var tpl = el.dataset.template || '[von] – [bis]';
      var html = tpl.replace('[von]', '<strong>' + fmt.format(a) + '</strong>').replace('[bis]', '<strong>' + fmt.format(b) + '</strong>');
      var out = $('[data-lp-delivery-text]', el);
      if (out) { out.innerHTML = html; el.hidden = false; }
    });
  }

  /* ---------- Sticky Kaufleiste ---------- */
  function initSticky(root) {
    $$('[data-lp-sticky]', root).forEach(function (bar) {
      if (bar.__lp) return; bar.__lp = true;
      var hero = bar.closest('[data-lp-hero]');
      var atc = hero && $('[data-lp-atc]', hero);
      if (!atc) return;
      var finals = $$('[data-lp-final]');
      var ticking = false;
      function render() {
        ticking = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var passed = atc.getBoundingClientRect().bottom < 0;
        var finalVisible = finals.some(function (f) {
          var r = f.getBoundingClientRect();
          return r.top < vh * 0.8 && r.bottom > 0;
        });
        var show = passed && !finalVisible;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if ('inert' in bar) bar.inert = !show;
        document.documentElement.classList.toggle('lp-sticky-on', show);
      }
      function onScroll() {
        if (ticking) return; ticking = true;
        requestAnimationFrame(render);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      render();
    });
  }

  /* ---------- Kaufen / Scrollen ---------- */
  function mainForm() { return $('form.lp-form'); }
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-lp-buy], [data-lp-scroll]');
    if (!link) return;
    var mode = link.getAttribute('data-lp-buy');
    var form = mainForm();
    if (mode === 'buy' && form) {
      // fester Artikel (z. B. Abschluss-CTA mit „folgt nicht der Auswahl“): oben dieses Angebot waehlen und genau diese Variante kaufen
      var vid = link.getAttribute('data-lp-variant');
      if (vid) {
        var r = $$('.lp-offer__radio').filter(function (x) { return x.value === vid; })[0];
        if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
        var vin = $('[data-lp-variant-input]', form);
        if (vin) vin.value = vid;
      }
      var atc = $('[data-lp-atc]', form);
      if (atc && atc.disabled) return;
      e.preventDefault();
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
      return;
    }
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) === '#' && href.length > 1) {
      var target = document.getElementById(href.slice(1));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('lp-form')) return;
    $$('[data-lp-atc]').forEach(function (b) { b.classList.add('is-loading'); });
  });
  window.addEventListener('pageshow', function () {
    $$('[data-lp-atc]').forEach(function (b) { b.classList.remove('is-loading'); });
  });

  function initAll(root) {
    initGallery(root); initOffers(root); initDelivery(root); initSticky(root);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
